/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import { useTranslation } from "react-i18next"; // Hook for handling translations
import { useNavigate, useParams } from "react-router-dom"; // Hooks for navigation and URL parameters
import { useState } from "react"; // React state hook
import { useSelector } from "react-redux"; // Hook to access the Redux store

// This component manages the state and behavior for employee details
// when accessed through the contractor flow contract screen.
const EmployeeDetailsFromContractorFlowContractApp = () => {
    const navigate = useNavigate(); // Function to programmatically navigate to routes
    const { t } = useTranslation(); // Function for handling internationalized text
    const { contractId } = useParams(); // Get the contract ID from the URL parameters

    // Load contractorId from sessionStorage to persist it across navigation
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));

    // State to control visibility of unlink confirmation modal
    const [unlinkShow, setUnlinkShow] = useState(false);

    // State to control visibility of delete employee confirmation modal
    const [deleteEmployeeShow, setDeleteEmployeeShow] = useState(false);

    // Get development flag from global Redux state
    const DEV = useSelector((state) => state?.CommonsSlice?.development);

    // Get user permissions from authentication state in Redux
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    // Return all necessary data and handlers to the component's consumer (typically the UI)
    return {
        t,
        DEV,
        permission,
        navigate,
        contractId,
        contractorId,
        unlinkShow,
        setUnlinkShow,
        deleteEmployeeShow,
        setDeleteEmployeeShow
    };
}

// Export the component so it can be used in other parts of the application
export default EmployeeDetailsFromContractorFlowContractApp;
